export default __webpack_public_path__ + "static/media/projectWall.e02193fa.bin";